
import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import Drawer from "../components/Drawer";
import LiveTop from "../components/LiveTop";
import Upcoming from "../components/Upcoming";
import Result from "../components/Result";
import FavouriteTeams from "../components/FavouriteTeams";
import TopPlayers from "../components/TopPlayers";
import {
  FaBroadcastTower,
  FaCalendarAlt,
  FaFlagCheckered,
  FaHeart,
} from "react-icons/fa";
import { FaPersonBurst } from "react-icons/fa6";
import styles from "../css/Matches.module.css";

const tabs = [
  { label: "Live/Top", icon: <FaBroadcastTower />, component: LiveTop },
  { label: "Upcoming", icon: <FaCalendarAlt />, component: Upcoming },
  { label: "Result", icon: <FaFlagCheckered />, component: Result },
  { label: "Favorites", icon: <FaHeart />, component: FavouriteTeams },
  { label: "Top-Players", icon: <FaPersonBurst />, component: TopPlayers },
];

const Matches = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const ActiveComponent = tabs[activeTab].component;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Layout active={null}>
      <Drawer active={null} />
      <div className={styles.container}>
        {isMobile ? (
          <div className={styles.customDropdown}>
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className={styles.dropdownButton}
            >
              <span className={styles.icon}>{tabs[activeTab].icon}</span>
              <span className={styles.label}>{tabs[activeTab].label}</span>
              <span className={styles.arrow}>▾</span>
            </button>
            {dropdownOpen && (
              <ul className={styles.dropdownList}>
                {tabs.map((tab, idx) => (
                  <li
                    key={idx}
                    className={`${styles.dropdownItem} ${
                      activeTab === idx ? styles.activeItem : ""
                    }`}
                    onClick={() => {
                      setActiveTab(idx);
                      setDropdownOpen(false);
                    }}
                  >
                    <span className={styles.icon}>{tab.icon}</span>
                    <span className={styles.label}>{tab.label}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ) : (
          <div className={styles.tabBar}>
            {tabs.map((tab, idx) => (
              <button
                key={idx}
                className={`${styles.tabButton} ${
                  activeTab === idx ? styles.active : ""
                }`}
                onClick={() => setActiveTab(idx)}
              >
                <span className={styles.icon}>{tab.icon}</span>
                <span className={styles.label}>{tab.label}</span>
              </button>
            ))}
          </div>
        )}

        <div className={styles.tabContent}>
          <ActiveComponent key={activeTab} />
        </div>
      </div>
    </Layout>
  );
};

export default Matches;
